import styled from 'styled-components';

export const StyledListItem = styled.li`
  margin-right: 0.5rem !important;
  display: inline-block;
  font-size: 1rem;
`;
